__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "@descomplica/classrooms-undergrad";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@descomplica/caching-browser", "1.0.5", function() { return function() { return __webpack_require__(58942); }; }, 1);
			register("@descomplica/microfrontend-core", "1.6.2", function() { return function() { return __webpack_require__(28421); }; }, 1);
			register("@descomplica/settings-browser", "2.0.14", function() { return function() { return __webpack_require__(50600); }; }, 1);
			register("axios", "0.27.2", function() { return function() { return __webpack_require__(9669); }; }, 1);
			register("class-validator", "0.14.1", function() { return function() { return __webpack_require__(93697); }; }, 1);
			register("mobx", "6.12.3", function() { return function() { return __webpack_require__(68949); }; }, 1);
			register("reflect-metadata", "0.2.2", function() { return function() { return __webpack_require__(8520); }; }, 1);
			register("tsyringe", "4.8.0", function() { return function() { return __webpack_require__(67817); }; }, 1);
			initExternal(79756);
			initExternal(28493);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};